import React  from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function Hpcom2(){
    return(
        <>
        <br/>
<br/>
<Row>
  <Col md={{offset:1,span:10  }}>
<h2 style={{color:"#0072F9",fontSize:"38px"}}>Difficulties & Solutions & Details</h2>
</Col>
</Row>
<br/>
<Row>
  <Col md={{offset:1,span:2}}>
</Col>
  <Col md={{span:1}}>
  <div class="sxtest"></div>
  </Col>
  <Col md={{span:7}}>
  After the CCiC conference, we got in touch with SYSU_Software's students. Through the communication, we learned that SYSU_Software's project was about mining Crispr-Cas-like defense systems, which was partly related to our team's topic.SYSU_Software's suggestions helped us to optimize our model. In addition, later in the project, we provided SYSU_Software with the results of data testing and validation, which also contributed to our project validation.
In fact, the collaboration between the two teams went far beyond the scope of "Collaboration". For more information, please 
see <a href="https://2022.igem.wiki/tongji-software/partnership">Partnership</a>.

<br/><br/><br/>
<img src="https://static.igem.wiki/teams/4272/wiki/hpc2.png" 
  alt="hpc2" width="800vw" style={{ borderRadius:"10%"}}/>

  </Col>
</Row>
        </>

    );
}
